import { render, staticRenderFns } from "./PricingAndMargin.vue?vue&type=template&id=33347d2f&"
import script from "./PricingAndMargin.vue?vue&type=script&lang=js&"
export * from "./PricingAndMargin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports